import React from "react";
import { Box, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import useCommonStyles from "./style";

// Presenting Complaint (Overview): the chatbot Symptom Analyzer's
// `clinical_summary` — primary_signal (main complaint) plus pattern & relief.
const PresentingComplaint = ({ summary }) => {
  const classes = useCommonStyles();

  const primary = summary && summary.primary_signal;
  if (!primary) {
    return (
      <Box className={classes.hiPlaceholder}>
        <InfoOutlinedIcon className={classes.hiPlaceholderIcon} />
        <Typography className={classes.hiPlaceholderNote}>
          No presenting complaint recorded for this patient yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.pcWrap}>
      <Typography className={classes.pcPrimary}>{primary}</Typography>

      {summary.pattern && (
        <Box className={classes.pcMetaRow}>
          <Typography className={classes.pcMetaLabel}>Pattern</Typography>
          <Typography className={classes.pcMetaValue}>
            {summary.pattern}
          </Typography>
        </Box>
      )}

      {summary.relief && (
        <Box className={classes.pcMetaRow}>
          <Typography className={classes.pcMetaLabel}>Relief</Typography>
          <Typography className={classes.pcMetaValue}>
            {summary.relief}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PresentingComplaint;
